import { Action, handleActions } from "redux-actions";
import { LAUNCHDARKLY_UPDATE } from "constants/action-types";
import { FeatureFlags } from "helpers/feature-flags";

export type LdFlagsState = FeatureFlags;
const initialState: LdFlagsState = {};

/**
 * Reducer representing the global state segment, which contains actual LaunchDarkly flags.
 */
const ldFlagsReducer = handleActions<LdFlagsState, LdFlagsState>(
    {
        [LAUNCHDARKLY_UPDATE]: (state: LdFlagsState, action: Action<LdFlagsState>) => ({
            ...action.payload,
        }),
    },
    initialState,
);

export default ldFlagsReducer;
